var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mc-tally',{staticClass:"new-class",attrs:{"model":_vm.model,"fluent":_vm.fluent},on:{"update:fluent":function($event){_vm.fluent=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }